// Domain types for Onboarding 2.0 feature
// Maps to GraphQL types from creator-api/src/onboarding-2.0/onboarding-two.contract.gql

export type OnboardingQuestionType = 'SINGLE_CHOICE' | 'OPEN_TEXT';

export type OnboardingAnswer = {
  id: string;
  title: string;
  subtitle: string | null;
  weight: number; // Default 1 if not provided from API
  chartValue: number; // Normalized 1-4 scale for chart rendering
};

export type OnboardingQuestion = {
  id: string;
  title: string;
  subtitle: string | null;
  type: OnboardingQuestionType;
  targetCategory: string | null; // Maps to radar chart axis (nullable)
  isRequired: boolean;
  answers: OnboardingAnswer[];
};

export type OnboardingResponse = {
  questionId: string;
  answerId: string | null;
  textValue: string | null;
};

export type ScoringCategory = {
  id: string;
  name: string; // Experience, Audience, Time, Goal, Help
};

export type ScoringRule = {
  id: string;
  strategyId: string;
  categoryId: string;
  minScore: number;
  maxScore: number;
};

export type CaseStudy = {
  id: string;
  strategyId: string;
  title: string;
  subtitle: string | null;
  description: string | null;
  coverImageHorizontalUrl: string;
  coverImageVerticalUrl: string;
  creatorName: string;
  creatorInstagramName: string;
  documentUrl: string;
};

export type Strategy = {
  id: string;
  name: string;
  tagline: string | null;
  description: string | null;
  superTitle: string | null;
  pills: string[];
  features: string[];
  priceLabel: string | null;
  programLengthLabel: string | null;
  launchTimeLabel: string | null;
  coverImageUrl: string | null;
  isRecommended: boolean;
  isActive: boolean;
  isSelected: boolean;
  caseStudies: CaseStudy[];
};

export type OnboardingDismissal = {
  webDismissedAt: string | null;
  mobileDismissedAt: string | null;
};

// Onboarding launch date - users registered before this date never see onboarding
export const ONBOARDING_LAUNCH_DATE = new Date('2026-01-15T00:00:00Z');
